<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="darkMode"
    :expand-on-hover="false"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
    :mini-variant="mini"
  >
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular display-2">
          <span class="logo mini-show">SSF</span>
          <!-- <span class="logo mini-hide">SaasForce</span> -->
          <v-img
            :src="logo"
            max-width="210"
            min-height="20"
            class="logo mini-hide"
          />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <!-- <v-list
      dense
      nav
    >
      <base-item-group :item="profile" />
    </v-list>-->

    <!-- <v-divider class="mb-2" /> -->

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        // {
        //   icon: 'mdi-view-dashboard',
        //   title: 'dashboard',
        //   to: '/',
        // },
        {
          icon: 'mdi-account-group',
          title: 'customers',
          to: '/customers',
        },
        {
          icon: 'mdi-animation',
          title: 'products',
          to: '/products',
        },
        {
          icon: 'mdi-archive',
          title: 'orders',
          to: '/orders',
        },
        {
          icon: 'mdi-autorenew',
          title: 'subscriptions',
          to: '/subscriptions',
        },
        {
          icon: 'mdi-account-settings',
          group: '/admin',
          title: 'Admin',
          permissions: ['OperatorAdmin'],
          children: [
            {
              icon: 'mdi-shopping',
              title: 'Resellers',
              to: 'resellers',
              permissions: ['OperatorAdmin'],
            },
            {
              icon: 'mdi-briefcase-outline',
              title: 'Reseller Orders',
              to: 'resellerorders',
              permissions: ['OperatorAdmin'],
            },
            {
              icon: 'mdi-file-document-edit',
              title: 'Manual Orders',
              to: 'manualorders',
              permissions: ['OperatorAdmin'],
            },
            {
              icon: 'mdi-file-table-box-multiple',
              title: 'Invoices',
              to: 'invoices',
              permissions: ['OperatorAdmin'],
            },
            {
              icon: 'mdi-human-male-female',
              title: 'Users',
              to: 'users',
              permissions: ['OperatorAdmin'],
            },
            {
              icon: 'mdi-pencil-box-multiple',
              title: 'Product Management',
              to: 'products',
              permissions: ['OperatorAdmin'],
            },
            {
              icon: 'mdi-cash-register',
              title: 'Sales',
              to: 'sales',
              permissions: ['OperatorAdmin'],
            },
          ],
        },
      ],
    }),

    computed: {
      ...mapState({
        darkMode: state => state.ui.drawerSettings.darkMode,
        mini: state => state.ui.drawerSettings.mini,
        logo: state => state.ui.contentSettings.PortalLogo,
      }),
      ...mapGetters(['userHasAccess']),
      drawer: {
        get () {
          return this.$store.state.ui.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items
          .filter(i => this.userHasAccess(i.permissions))
          .map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          group: '',
          title: this.$t('avatar'),
          children: [
            {
              href: '',
              title: this.$t('my-profile'),
            },
            {
              to: '',
              title: this.$t('edit-profile'),
            },
            {
              to: '',
              title: this.$t('settings'),
            },
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },
    created: async function () {
      if (!this.logo) { this.$store.dispatch('RefreshContentSettings') }
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children
            ? item.children
              .filter(i => this.userHasAccess(i.permissions))
              .map(this.mapItem)
            : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

    .mini-hide
      display: none
    .mini-show
      display: inherit

  .mini-show
    display: none
  .mini-hide
    display: inherit
  .logo
    text-align: center

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
